/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { BANK_DATA, BANK_TYPE } from "../../../../constants/BANK_DATA";
import Modal, { ModalHeader } from "../../../../components/Modal";
import Radios from "../../../../components/Radio/Radios";
import Button from "../../../../components/Button";
import { findIndex, forEach, isEmpty } from "lodash";
import {
  getFinancesType,
  modifyFinancesAccounts,
  postFinancesAuth,
} from "../../../../apis/finances/auth";
import FinancesCert from "../../../../components/FinancesCert/idnex";
import { classnames } from "../../../../utils/text";
import Input from "../../../../components/Input";
import Loading from "../../../../components/Loading";
// import { viewLoading } from "../../../../utils/loading";

const BankAccount = ({ open, setOpen, submit, mode, financeData, setFinanceData }) => {
  // 인증서 state
  const [isFinancesCertShow, setIsFinancesCertShow] = useState(false);
  // 계좌 구분
  const [orgCd, setOrgCd] = useState("cbk");
  const [loginMethod, setLoginMethod] = useState("CERT");
  const [certInfo, setCertInfo] = useState({
    userId: "",
    userPw: "",
  });
  const [isHidePassword, setIsHidePassword] = useState(true);
  // 은행 리스트
  const [bankList, setBankList] = useState([]);
  // 선택된 은행
  const [selected, setSelected] = useState({});
  // 페이지 단계
  const [step, setStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // 은행 리스트 다시 세팅
    getBankList();

    const radioButton = document.getElementsByName("bank-account-radio");

    const setRadioButton = () => {
      if (!isEmpty(financeData)) {
        const bankIdx = findIndex(bankList, (bank) => bank.code === financeData.bankCd);
        if (!isEmpty(radioButton)) {
          radioButton[bankIdx].checked = true;
          setSelected(bankList[bankIdx]);
        }
      } else {
        // 구분 변경시 radio checked 해제
        if (!isEmpty(radioButton)) {
          for (var i = 0; i < radioButton.length; i++)
            radioButton[i].checked = false;
        }
        // 선택된 은행 데이터 리셋
        setSelected({});
      }
    };
    process.nextTick(setRadioButton);
  }, [orgCd, financeData]);

  useEffect(() => {
    if (!isEmpty(financeData)) {
      setOrgCd(financeData.orgCd);
    }
  }, [financeData]);

  const getBankList = () => {
    getFinancesType(orgCd).then((res) => {
      const transDatas = [];
      forEach(res.data, (apiData) => {
        forEach(BANK_DATA, (data) => {
          if (apiData.fcode === data.fcode) {
            transDatas.push({ ...apiData, bankImg: data.bankImg });
          }
        });
      });
      setBankList(transDatas);
    });
  };

  const cancel = (e) => {
    reset();
    setOpen(false);
  };

  const handleOnChangeType = (e) => {
    const { value } = e.target;
    setOrgCd(value);
  };

  const handleOnSelectBank = (e) => {
    setSelected(bankList[e.target.value]);
  };

  const handleNextStep = () => {
    if (isEmpty(selected)) return;

    // 선택된 은행의 인증방식이 인증서 방식 하나인 경우.
    if (selected.methods.length === 1 && selected.methods.includes("CERT")) {
      setIsFinancesCertShow(true);
      return;
    }
    setStep(1);
  };

  const _submit = (certData) => {
    setIsLoading(true);
    let formData = {};
    switch (loginMethod) {
      case "CERT":
        formData = {
          orgCd,
          loginMethod,
          signCert: certData.DER2PEM,
          signPri: certData.KEY2PEM,
          signPw: certData.password,
          signType: orgCd === "cbk" ? 0 : 1,
          signName: certData.certName,
          signProvider: certData.pub,
          signExpired: certData.toDt,
          bankCd: selected.code,
        };
        break;
      case "ID":
        formData = {
          orgCd,
          loginMethod,
          userId: certInfo.userId,
          userPw: certInfo.userPw,
          bankCd: selected.code,
        };
        break;
      default:
        break;
    }

    if (isEmpty(financeData)) {
      // 새로운 등록
      postFinancesAuth(formData)
        .then(() => {
          setOpen(false);
          reset();
          submit();
        })
        // .catch((err) => {
        //   console.log(err.response.message);
        // })
        .finally(() => setIsLoading(false));
    } else {
      // 수정
      delete formData.orgCd;
      modifyFinancesAccounts(financeData.idx, formData).then(() => {
        setOpen(false);
        reset();
        submit();
      })
        // .catch((err) => {
        //   console.log(err.response.message);
        // })
        .finally(() => setIsLoading(false));
    }
  };

  const handleSecondStep = () => {
    //console.log("두번째 스텝 액션");
    switch (loginMethod) {
      case "CERT":
        setIsFinancesCertShow(true);
        break;
      case "ID":
        _submit();
        break;
      default:
        break;
    }
  };

  const getSecondStepSubmitDisabled = () => {
    // 두번째 스탭 버튼 disabled 함수
    let isDisabled = true;
    // 인증서 방식일 경우 disabled false
    if (loginMethod === "CERT") isDisabled = false;
    // 아이디 로그인 방식일 경우 userId와 userPw가 모두 입력 되어있을 경우 disabled false
    if (
      loginMethod === "ID" &&
      !isEmpty(certInfo.userId) &&
      !isEmpty(certInfo.userPw)
    )
      isDisabled = false;

    return isDisabled;
  };

  const handleOnChangeId = (e) => {
    const { name, value } = e.target;
    setCertInfo({
      ...certInfo,
      [name]: value,
    });
  };

  const reset = () => {
    setCertInfo({
      userId: "",
      userPw: "",
    });
    setLoginMethod("CERT");
    setFinanceData({});
    setOrgCd("cbk");
    setSelected({});
    setStep(0);
  };

  return (
    <>
      <Modal isOpen={open} close={cancel}>
        {isLoading ?
          <Loading /> : (
            <div className="bank-account-connect-page">
              {step === 0 && (
                <div className="first-step-container">
                  <ModalHeader>{mode === 'create' ? '새 은행계좌 연동' : '은행 인증 정보 변경'}</ModalHeader>
                  <p className="account-type description">
                    연동할 계좌를 구분해주세요
                  </p>
                  <Radios
                    field={{
                      key: "orgCd",
                      defaultChecked: orgCd,
                      options: { list: BANK_TYPE },
                      onChange: handleOnChangeType,
                    }}
                    disabled={!isEmpty(financeData)}
                    className="bank-account-radios"
                  />
                  <p className="bank-account description">
                    연동할 계좌의 은행을 선택해주세요
                  </p>
                  <div className="bank-list-container">
                    {bankList.map((data, idx) => (
                      <React.Fragment key={idx}>
                        <input
                          id={`bank-account-${idx}`}
                          className="bank-select-radio"
                          name="bank-account-radio"
                          type="radio"
                          value={idx}
                          disabled={!isEmpty(financeData)}
                          onChange={handleOnSelectBank}
                        />
                        <label
                          htmlFor={`bank-account-${idx}`}
                          className="bank-list-wrap"
                        >
                          <div className="bank-info-wrap">
                            <div className="bank-image-wrap">
                              <img src={data.bankImg} alt={data.name} />
                            </div>
                            <p className="bank-name">{data.name}</p>
                          </div>
                        </label>
                      </React.Fragment>
                    ))}
                  </div>
                  <div className="control-button-wrap">
                    <Button
                      className="cancel-button"
                      label="다음"
                      disabled={isEmpty(selected)}
                      onClick={handleNextStep}
                    />
                    <Button
                      className="cancel-button"
                      color="text"
                      label="취소"
                      onClick={cancel}
                    />
                  </div>
                </div>
              )}
              {step === 1 && (
                //
                <div className="second-step-container">
                  <ModalHeader>
                    <div className="bank-image-wrap">
                      <img src={selected.bankImg} alt={selected.name} />
                    </div>
                    {selected.name} 연동
                  </ModalHeader>
                  <p className="bank-account description">
                    연동할 계좌의 은행을 선택해주세요
                  </p>
                  <Radios
                    field={{
                      key: "loginMethod",
                      defaultChecked: loginMethod,
                      options: {
                        list: [
                          { label: "공인인증서", value: "CERT" },
                          {
                            label: `${selected.name} 아이디, 패스워드 입력`,
                            value: "ID",
                          },
                        ],
                      },
                      onChange: (e) => {
                        setCertInfo({ userId: "", userPw: "" });
                        setLoginMethod(e.target.value);
                      },
                    }}
                    className="bank-account-radios"
                  />
                  {loginMethod === "ID" && (
                    <div className="cert-id-login-container">
                      <div className="bank-company-warp">
                        <div className="bank-img-container">
                          <div className="bank-img-wrap">
                            <img src={selected.bankImg} alt={selected.name} />
                          </div>
                        </div>
                      </div>
                      <form className="cert-id-login-form">
                        <div className="input-wrap id">
                          <label className="input-label">아이디</label>
                          <Input
                            className="id-input"
                            name="userId"
                            value={certInfo.userId}
                            onChange={handleOnChangeId}
                            placeholder="아이디를 입력해주세요"
                          />
                        </div>
                        <div className="input-wrap password">
                          <label className="input-label">패스워드</label>
                          <Input
                            className="password-input"
                            name="userPw"
                            type={isHidePassword ? "password" : "text"}
                            value={certInfo.userPw}
                            onChange={handleOnChangeId}
                            autoComplete="off"
                            placeholder="패스워드를 입력해주세요"
                          />
                          <span className="icon">
                            <i
                              className={`mdi ${isHidePassword ? "mdi-eye" : "mdi-eye-off"
                                } font-size-24`}
                              onClick={() => setIsHidePassword(!isHidePassword)}
                            />
                          </span>
                        </div>
                      </form>
                    </div>
                  )}
                  <div
                    className={classnames("control-button-wrap", {
                      isCert: loginMethod === "CERT",
                    })}
                  >
                    <Button
                      className="cancel-button"
                      label="다음"
                      disabled={getSecondStepSubmitDisabled()}
                      onClick={handleSecondStep}
                    />
                    <Button
                      className="cancel-button"
                      color="text"
                      label="취소"
                      onClick={cancel}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
      </Modal>

      <FinancesCert
        isShow={isFinancesCertShow}
        toggle={setIsFinancesCertShow}
        submit={_submit}
      ></FinancesCert>
    </>
  );
};

export default BankAccount;
